// =============================================================================
// SentryTestButton — TEMPORAL (verificación de Sentry post-deploy).
// QUITAR en v1.3.0.
//
// Solo se renderiza si VITE_SENTRY_TEST === 'true' (var de build, inline).
// Al hacer click lanza un Error no manejado → lo captura el global handler de
// Sentry (no es un 4xx, así que no lo filtra beforeSend).
// =============================================================================
export function SentryTestButton() {
  if (import.meta.env.VITE_SENTRY_TEST !== 'true') return null;

  return (
    <div className="mt-6 rounded-xl border border-dashed border-amber-300 bg-amber-50 p-4">
      <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-amber-700">
        DEV — Sentry
      </p>
      <p className="mt-1 text-xs text-amber-800">
        Dispara un error de prueba para verificar que Sentry lo captura.
        Quitar en v1.3.0.
      </p>
      <button
        type="button"
        onClick={() => {
          throw new Error(
            'Sentry test error from frontend ' + new Date().toISOString(),
          );
        }}
        className="mt-3 inline-flex items-center gap-2 rounded-lg bg-amber-600 px-3 py-2 text-xs font-medium text-white hover:bg-amber-700"
      >
        Test Sentry Error
      </button>
    </div>
  );
}
